import axios from 'axios'
import config from '../../config.json'
const hostname = window.location.hostname
axios.defaults.baseURL = `${config?.hostname2 === hostname
    ? config.requestURL2
    : config?.hostname === hostname
      ? config.requestURL
      : config.requestURL
  }/api`
const instance = axios.create()

export function request(method, url, data) {
  return instance({ method, url, data })
}
export function requestAuth(method, url, data, params) {
  return axios({
    method,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token_seguridad'),
    },
    url,
    data,
    params
  })
}
